/* ==========================================================================
   Gadea Loreak — PLP (página de colección)
   Filtros/orden nativos de Shopify: drawer en móvil, sidebar en escritorio,
   auto-submit en escritorio, slider de precio de doble mango, grupos plegables
   y "Leer más" en la descripción.
   ========================================================================== */
(function () {
  'use strict';

  var DESKTOP = '(min-width: 990px)';

  function toNum(v) {
    if (v == null) return NaN;
    return parseFloat(String(v).replace(',', '.'));
  }

  function fmt(v) {
    // El cliente quiere ENTEROS en el filtro de precio (sin decimales).
    return String(Math.round(v));
  }

  function initPLP(root) {
    if (root.dataset.plpReady) return;
    root.dataset.plpReady = '1';

    var mq = window.matchMedia(DESKTOP);
    var isDesktop = function () { return mq.matches; };

    var toggle = root.querySelector('[data-plp-filter-toggle]');
    var panel = root.querySelector('[data-plp-panel]');
    var overlay = root.querySelector('[data-plp-overlay]');
    var closeBtn = root.querySelector('[data-plp-panel-close]');
    var form = root.querySelector('[data-plp-form]');

    /* ---------- Refresco AJAX (Section Rendering API): sin recarga ni saltos ---------- */
    var sectionId = root.getAttribute('data-section-id');
    var rendering = false;
    var pendingUrl = null; // última URL pedida mientras hay un render en vuelo (coalesce)
    function buildFormUrl() {
      if (!form) return location.href;
      var qs = new URLSearchParams(new FormData(form)).toString();
      return (form.getAttribute('action') || location.pathname) + (qs ? '?' + qs : '');
    }
    function fetchSection(url) {
      var sep = url.indexOf('?') === -1 ? '?' : '&';
      return fetch(url + sep + 'section_id=' + sectionId, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.text(); })
        .then(function (html) { return new DOMParser().parseFromString(html, 'text/html'); });
    }
    function scrollToTop(smooth) {
      var top = root.getBoundingClientRect().top + window.scrollY - 90;
      if (window.scrollY > top + 4) window.scrollTo({ top: top, behavior: smooth ? 'smooth' : 'auto' });
    }
    // Filtros/precio/orden: intercambia SOLO los resultados (la barra de filtros y su estado se conservan)
    function renderResults(url, opts) {
      opts = opts || {};
      if (!sectionId) { location.href = url; return; }
      // Si ya hay un render en vuelo, NO descartamos el cambio: recordamos la ÚLTIMA
      // URL pedida y la renderizamos al terminar. Antes un `if (rendering) return`
      // seco tiraba el cambio si el usuario filtraba mientras cargaba el anterior
      // (red lenta o clics rápidos > debounce) → "no se actualiza al filtrar".
      if (rendering) { pendingUrl = url; return; }
      rendering = true;
      var main = root.querySelector('[data-plp-main]');
      if (main) { main.style.minHeight = main.offsetHeight + 'px'; main.classList.add('is-loading'); }
      fetchSection(url).then(function (doc) {
        var nMain = doc.querySelector('[data-plp-main]');
        if (nMain && main) main.innerHTML = nMain.innerHTML;
        if (!opts.noPush) history.pushState({ plp: 1 }, '', url);
        if (main) { main.classList.remove('is-loading'); requestAnimationFrame(function () { main.style.minHeight = ''; }); }
        scrollToTop(true);
      }).catch(function () { if (main) { main.classList.remove('is-loading'); main.style.minHeight = ''; } })
        .finally(function () {
          rendering = false;
          // Llegó una selección más nueva mientras renderizábamos → aplicarla ahora.
          if (pendingUrl && pendingUrl !== url) {
            var next = pendingUrl; pendingUrl = null;
            renderResults(next, opts);
          } else {
            pendingUrl = null;
          }
        });
    }
    // Cambio de subcategoría: cambia toda la colección → intercambia el bloque entero y re-inicializa
    function renderFull(url, opts) {
      opts = opts || {};
      if (!sectionId) { location.href = url; return; }
      if (rendering) return;
      rendering = true;
      root.classList.add('is-swapping');
      fetchSection(url).then(function (doc) {
        var nRoot = doc.querySelector('[data-plp]');
        if (nRoot) {
          root.innerHTML = nRoot.innerHTML;
          root.dataset.plpReady = '';
          root.classList.remove('is-swapping');
          initPLP(root); // re-engancha filtros/slider/subcats sobre el DOM nuevo
        } else { root.classList.remove('is-swapping'); }
        if (!opts.noPush) history.pushState({ plp: 1, full: 1 }, '', url);
        scrollToTop(false);
      }).catch(function () { root.classList.remove('is-swapping'); })
        .finally(function () { rendering = false; });
    }
    root.__renderResults = renderResults;
    root.__renderFull = renderFull;
    // Delegación en el root (persiste entre re-renders): subcategorías + historial. Solo una vez.
    if (!root.__plpDelegated) {
      root.__plpDelegated = true;
      root.addEventListener('click', function (e) {
        var sub = e.target.closest('.iurop-subcats a');
        if (sub && !e.metaKey && !e.ctrlKey && !e.shiftKey && e.button === 0) {
          e.preventDefault();
          if (root.__renderFull) root.__renderFull(sub.getAttribute('href'));
        }
      });
      window.addEventListener('popstate', function () {
        if (root.__renderFull) root.__renderFull(location.href, { noPush: true });
      });
    }

    /* ---------- Estado abierto/cerrado ---------- */
    function lockBody(on) {
      document.documentElement.style.overflow = (on && !isDesktop()) ? 'hidden' : '';
    }
    function syncAria() {
      if (toggle) toggle.setAttribute('aria-expanded', String(root.classList.contains('is-filters-open')));
    }
    function openFilters() {
      root.classList.add('is-filters-open');
      lockBody(true);
      syncAria();
    }
    function closeFilters() {
      root.classList.remove('is-filters-open');
      lockBody(false);
      syncAria();
    }
    function applyDefault() {
      // En escritorio los filtros nacen abiertos; en móvil cerrados.
      if (isDesktop()) {
        root.classList.add('is-filters-open');
      } else {
        root.classList.remove('is-filters-open');
      }
      lockBody(false);
      syncAria();
    }
    applyDefault();
    if (mq.addEventListener) {
      mq.addEventListener('change', applyDefault);
    } else if (mq.addListener) {
      mq.addListener(applyDefault);
    }

    if (toggle) {
      toggle.addEventListener('click', function () {
        root.classList.contains('is-filters-open') ? closeFilters() : openFilters();
      });
    }
    if (closeBtn) closeBtn.addEventListener('click', closeFilters);
    if (overlay) overlay.addEventListener('click', closeFilters);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !isDesktop() && root.classList.contains('is-filters-open')) {
        closeFilters();
      }
    });

    /* ---------- Auto-submit (solo escritorio, debounce ~250ms) → AJAX ---------- */
    var submitTimer = null;
    function autoSubmit() {
      // Auto-actualiza en vivo TANTO en escritorio (sidebar) COMO en móvil/tablet
      // (drawer): quitamos el botón "Ver resultados" en móvil, así que el `change`
      // de cada casilla/orden/slider aplica solo. El drawer NO se cierra (los
      // resultados cambian detrás, [data-plp-main] fuera del panel); la X cierra.
      if (submitTimer) clearTimeout(submitTimer);
      submitTimer = setTimeout(function () { renderResults(buildFormUrl()); }, 250);
    }
    if (form) {
      form.querySelectorAll('input[type="checkbox"], input[type="radio"]').forEach(function (inp) {
        inp.addEventListener('change', autoSubmit);
      });
      // Envío del formulario (móvil "Ver resultados" o Enter) → AJAX + cerrar drawer en móvil
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        renderResults(buildFormUrl());
        if (!isDesktop()) closeFilters();
      });
    }

    /* ---------- Grupos plegables ---------- */
    root.querySelectorAll('[data-plp-group-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('[data-plp-group]');
        if (!group) return;
        var collapsed = group.classList.toggle('is-collapsed');
        btn.setAttribute('aria-expanded', String(!collapsed));
      });
    });

    /* ---------- "Leer más" en descripción ---------- */
    var desc = root.querySelector('[data-plp-desc]');
    if (desc) {
      var txt = desc.querySelector('[data-plp-desc-text]');
      var tgl = desc.querySelector('[data-plp-desc-toggle]');
      if (txt && tgl) {
        requestAnimationFrame(function () {
          if (txt.scrollHeight <= txt.clientHeight + 2) {
            tgl.hidden = true;
          }
        });
        tgl.addEventListener('click', function () {
          var expanded = desc.classList.toggle('is-expanded');
          tgl.textContent = expanded
            ? (tgl.getAttribute('data-less') || 'Leer menos')
            : (tgl.getAttribute('data-more') || 'Leer más');
        });
      }
    }

    /* ---------- Sliders de precio ---------- */
    root.querySelectorAll('[data-plp-range]').forEach(function (rng) {
      initRange(rng, autoSubmit);
    });
  }

  function initRange(rng, autoSubmit) {
    var wrap = rng.closest('[data-plp-group]') || rng.parentNode;
    var minR = rng.querySelector('[data-plp-range-min]');
    var maxR = rng.querySelector('[data-plp-range-max]');
    var fill = rng.querySelector('[data-plp-range-fill]');
    var numMin = wrap.querySelector('[data-plp-num-min]');
    var numMax = wrap.querySelector('[data-plp-num-max]');
    var outMin = wrap.querySelector('[data-plp-out-min]');
    var outMax = wrap.querySelector('[data-plp-out-max]');
    if (!minR || !maxR || !numMin || !numMax) return;

    var max = toNum(numMin.getAttribute('max')) || toNum(numMax.getAttribute('max')) || 100;
    if (!isFinite(max) || max <= 0) max = 100;

    /* SUELO del slider = precio del producto MÁS BARATO de la colección.
       Lo emite Liquid en [data-plp-range-floor] y en el `min` de los inputs
       numéricos (`filter.range_min` NO existe en Liquid, solo `range_max`).
       Antes el extremo izquierdo era siempre 0 aunque la colección empezara en
       28€ → la mitad izquierda de la barra no filtraba nada (queja del cliente:
       "EMPIEZA DESDE EL PRECIO MÁS BAJO Y OPTIMIZAR LA BARRA CON SU LÓGICA"). */
    var min = toNum(rng.getAttribute('data-plp-range-floor'));
    if (!isFinite(min)) min = toNum(numMin.getAttribute('min'));
    // `min === max` es LEGÍTIMO (colección de precio único, p.ej. todas las velas
    // a 15 €): antes ese caso caía en `min >= max` y devolvía el suelo a 0, que es
    // justo la queja del cliente ("arranca en 0 aunque el más barato cueste más").
    // Solo se descarta un suelo imposible (no numérico, negativo o mayor que el techo).
    if (!isFinite(min) || min < 0 || min > max) min = 0;

    var curMin = numMin.value !== '' ? toNum(numMin.value) : min;
    var curMax = numMax.value !== '' ? toNum(numMax.value) : max;
    if (!isFinite(curMin)) curMin = min;
    if (!isFinite(curMax)) curMax = max;

    /* Escala LOGARÍTMICA — CLONADA del filtro de cafeshi (assets/main-collection.js)
       y DESPLAZADA al suelo real de la colección: los range trabajan en
       posiciones 0..SCALE y el precio se deriva con
         precio = min + (max − min + 1)^(pos/SCALE) − 1
         inversa: pos = SCALE · ln(p − min + 1) / ln(max − min + 1)
       Propiedades que se conservan: pos 0 → `min` EXACTO y pos SCALE → `max`
       EXACTO (sin casos especiales), la curva reparte TODO el recorrido entre
       [min, max] (antes malgastaba el tramo 0..min), y para rangos cortos la
       curva ya es casi lineal (no hace falta rama lineal de respaldo). Redondeo
       a ENTERO en el resultado (posToPrice/fmt), como pide el cliente. */
    var SCALE = 1000;
    var SPAN = max - min + 1;

    function posToPrice(pos) {
      var t = pos / SCALE;
      if (t <= 0) return Math.round(min);
      if (t >= 1) return Math.round(max);
      var v = min + Math.pow(SPAN, t) - 1;
      // Curva logarítmica intacta; solo el RESULTADO se redondea a ENTERO
      // (petición del cliente: sin decimales en el filtro de precio).
      return Math.round(v);
    }
    function priceToPos(v) {
      if (!isFinite(v) || v <= min) return 0;
      if (v >= max) return SCALE;
      // SPAN <= 1 = colección de precio único: no hay recorrido que repartir
      // (además Math.log(1) = 0 haría una división por cero).
      if (SPAN <= 1) return 0;
      var t = Math.log(v - min + 1) / Math.log(SPAN);
      return Math.round(Math.min(Math.max(t, 0), 1) * SCALE);
    }

    [minR, maxR].forEach(function (s) {
      s.min = 0;
      s.max = SCALE;
      s.step = 1;
    });
    minR.value = priceToPos(curMin);
    maxR.value = priceToPos(curMax);

    function paint() {
      var a = parseFloat(minR.value);
      var b = parseFloat(maxR.value);
      if (a > b) { var t = a; a = b; b = t; }
      var pMin = (a / SCALE) * 100;
      var pMax = (b / SCALE) * 100;
      if (fill) {
        fill.style.left = pMin + '%';
        fill.style.right = (100 - pMax) + '%';
      }
      var priceA = posToPrice(a);
      var priceB = posToPrice(b);
      if (outMin) outMin.textContent = fmt(priceA);
      if (outMax) outMax.textContent = fmt(priceB);
      minR.setAttribute('aria-valuetext', fmt(priceA));
      maxR.setAttribute('aria-valuetext', fmt(priceB));
    }

    function commit() {
      var a = parseFloat(minR.value);
      var b = parseFloat(maxR.value);
      if (a > b) { var t = a; a = b; b = t; minR.value = a; maxR.value = b; }
      var priceA = posToPrice(a);
      var priceB = posToPrice(b);
      // En el SUELO no se manda el parámetro (equivale a "sin mínimo"): así la
      // URL queda limpia y el filtro no excluye por redondeo el producto más barato.
      numMin.value = priceA > min ? priceA : '';
      numMax.value = priceB < max ? priceB : '';
      paint();
      // El precio aplica en 'change' (al soltar el mango), nunca en cada 'input'.
      autoSubmit();
    }

    // Los mangos no se cruzan: cada uno topa contra el otro mientras se arrastra
    // (antes se cruzaban y el valor se "desintercambiaba" al soltar, así que la
    // lectura de la barra no coincidía con lo que se estaba arrastrando).
    minR.addEventListener('input', function () {
      if (parseFloat(minR.value) > parseFloat(maxR.value)) minR.value = maxR.value;
      paint();
    });
    maxR.addEventListener('input', function () {
      if (parseFloat(maxR.value) < parseFloat(minR.value)) maxR.value = minR.value;
      paint();
    });
    minR.addEventListener('change', commit);
    maxR.addEventListener('change', commit);

    paint();
  }

  function init() {
    document.querySelectorAll('[data-plp]').forEach(initPLP);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-inicializa en el editor de temas al recargar la sección.
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-plp]');
    if (root) initPLP(root);
  });
})();
